import { render, staticRenderFns } from "./ExportComponentButton.vue?vue&type=template&id=408895b1&scoped=true&"
import script from "./ExportComponentButton.vue?vue&type=script&lang=js&"
export * from "./ExportComponentButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportComponentButton.vue?vue&type=style&index=0&id=408895b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408895b1",
  null
  
)

export default component.exports